import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadSerenityConfig } from "../../../api/serenityConfig";
import { Modal } from "../../common/Modal";
import { useSerenityConfigs } from "./SerenityConfigs";

const formatDate = (date: string) => new Date(date).toLocaleDateString();

// Monté seulement quand la modale est ouverte : les sauvegardes ne sont pas demandées pour
// chaque produit au chargement de la page.
const SerenityConfigsList = ({ uuid }: { uuid: string }) => {
  const { t } = useTranslation();
  const { configs, isLoading, failed } = useSerenityConfigs(uuid);
  const [downloadFailed, setDownloadFailed] = useState(false);

  if (isLoading) return <p className="text-sm">{t("loading")}</p>;
  if (failed) return <p className="text-sm">{t("serenity-configs-error")}</p>;
  if (configs.length === 0) {
    return <p className="text-sm">{t("serenity-configs-none")}</p>;
  }

  const download = (id: number) => {
    setDownloadFailed(false);
    downloadSerenityConfig(uuid, id).catch(() => setDownloadFailed(true));
  };

  return (
    <div className="space-y-2">
      <ul className="space-y-2">
        {configs.map((config) => (
          <li key={config.id}>
            <button
              type="button"
              className="w-full flex items-center gap-3 rounded-lg border border-grey-light px-3 py-2 text-sm text-left hover:border-secondary hover:text-secondary"
              onClick={() => download(config.id)}
            >
              <FontAwesomeIcon icon="download" className="text-secondary" />
              {t("serenity-configs-download", {
                date: formatDate(config.date),
                version: config.version,
              })}
            </button>
          </li>
        ))}
      </ul>
      {downloadFailed && (
        <p className="text-xs text-warning-readable">
          {t("serenity-configs-download-error")}
        </p>
      )}
    </div>
  );
};

/** Bouton icône d'une ligne produit serenity, qui ouvre le choix de la sauvegarde à télécharger. */
export const SerenityConfigsButton = ({ uuid }: { uuid: string }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const label = t("serenity-configs-title");

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        title={label}
        aria-label={label}
        className="w-8 h-8 flex items-center justify-center rounded-lg text-secondary hover:text-tertiary"
      >
        <FontAwesomeIcon icon="clock-rotate-left" />
      </button>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title={label}>
        <SerenityConfigsList uuid={uuid} />
      </Modal>
    </>
  );
};
